import React from 'react';

import FlexLink from '@components/FlexLink';
import { CONTACT_LIST } from '@utils/constants';

const ContactUs = () => {
  const contactValue = (contact) => {
    if (contact.as) {
      return contact.as;
    } else if (contact.email) {
      return contact.email;
    } else {
      return contact.link;
    }
  };
  return (
    <div>
      <h2 className="mb-24 font-suisse-works text-headline-md">Contact Us</h2>
      <div className="grid grid-cols-1 gap-32 font-suisse-screen text-disclosure-lg sm:grid-cols-2">
        {CONTACT_LIST.map((contact) => (
          <address key={contact.title} className="max-w-[424px] not-italic">
            <div>{contact.title}</div>
            <p className="my-0">
              <FlexLink
                href={contact.link ? contact.link : `mailto:${contact.email}`}
                className="block hover:text-primary-magenta"
              >
                {contactValue(contact)}
              </FlexLink>
            </p>
          </address>
        ))}
      </div>
    </div>
  );
};

export default ContactUs;
